<template>
  <div>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="false"
      label-width="80px"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: '/station/model/page',
      columns: [
        {
          label: '电桩品牌',
          prop: 'brandName'
        }, {
          label: '电桩型号',
          prop: 'modelName'
        }, {
          label: '充电枪数量',
          prop: 'number'
        }, {
          label: '电桩类型',
          prop: 'type',
          template: (index, record) => {
            if (record.type == 0) {
              return '直流'
            } else if (record.type == 1) {
              return '交流'
            } else {
              return '未知'
            }
          }
        }, {
          label: '电桩功率（kW）',
          prop: 'power'
        }, {
          label: '创建时间',
          prop: 'createDate'
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '修改',
            permission: 'system.electric.pile.type.management.update',
            handle: (resp) => {
              this.$router.push({
                path: 'stationModelModify',
                query: { id: resp.id }
              })
            }
          }
        ]
      },
      query: [
        {
          label: '品牌名称',
          prop: 'brandName',
          placeholder: '请输入品牌名称'
        }, {
          label: '电桩型号',
          prop: 'modelName',
          placeholder: '请输入电桩型号'
        }, {
          label: '电桩类型',
          prop: 'type',
          placeholder: '请选择电桩类型',
          type: 'select',
          data: [{
            label: '交流',
            value: '1'
          }, {
            label: '直流',
            value: '0'
          }]
        }, {
          label: '创建时间',
          prop: 'createTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'system.electric.pile.type.management.add',
          type: 'primary',
          before: (index, record) => {
            this.$router.push({
              path: 'stationModelAdd'
            })
          }
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/stationModel.vue